import { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface FloatingBookCTAProps {
  onOpenModal: () => void;
}

const FloatingBookCTA = ({ onOpenModal }: FloatingBookCTAProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('footer');
      const footerTop = footer?.getBoundingClientRect().top ?? Infinity;
      const windowHeight = window.innerHeight;
      
      // Show after scrolling 400px, hide when footer is visible
      const pastScrollThreshold = window.scrollY > 400;
      const footerVisible = footerTop < windowHeight + 100;
      
      setIsVisible(pastScrollThreshold && !footerVisible);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-300 ${
        isVisible 
          ? 'opacity-100 translate-y-0' 
          : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <Button
        onClick={onOpenModal}
        className="bg-[#ffdb4d] hover:bg-[#ffdb4d]/90 text-[#0D1B2A] font-semibold px-5 py-6 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2"
      >
        <Calendar className="h-5 w-5" />
        <span className="hidden sm:inline">Book Now</span>
      </Button>
    </div>
  );
};

export default FloatingBookCTA;
